import type {
  PagePanelsState,
  PagePanelsReducerActions,
} from '../types/page-state.js';
import { PagePanelsActions } from '../types/page-state.js';

/** Page state reducer function used for managing the state of the panels. */
export function pageStateReducer(
  state: PagePanelsState,
  action: PagePanelsReducerActions,
): PagePanelsState {
  const { type, payload } = action;
  const newState: PagePanelsState = { ...state };

  // SET any of the panel's state props.
  if (type === PagePanelsActions.SETPANEL) {
    const {
      name,
      defaultDismissed,
      controlled,
      drawer,
      breakpoint,
      userAction,
    } = payload;

    newState[name] = {
      ...state[name],
      controlled: controlled ?? state[name].controlled,
      defaultDismissed: defaultDismissed ?? state[name].defaultDismissed,
      drawer: drawer ?? state[name].drawer,
      breakpoint: breakpoint ?? state[name].breakpoint,
      userAction: userAction ?? state[name].userAction,
    };

    return newState;
  }

  return state;
}
